const formatMoneyAmount = (amount) =>
    `${(amount / 100).toLocaleString("de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })} €`;

export { formatMoneyAmount };
